import React from 'react'
import Chart, { ArgumentAxis, Legend, Size, CommonSeriesSettings, Series, Tooltip, ValueAxis } from 'devextreme-react/chart';
import { generateElement } from "./FactoryUtil";
import WorldMap from "./WorldMap/WorldMap";
import PieChartDex from "./PieChart/PieChart";
import SplineChart from "./SplineChart/SplineChart";
import Doughnut from "./Doughnut/Doughnut";
import StackedBar from "./StackedBar/StackedBar";
import StackedBarCompare from "./StackedBar/StackedBarCompare";
import StackedBarLoss from "./StackedBar/StackedBarLoss";
import TreeMaping from "./TreeMap/TreeMap";
import FunnelChart from "./FunelChart/FunnelChart";
import BubbleChart from "./BubbelChart/BubbleChart";
import { Icon } from 'office-ui-fabric-react/lib';
import { MyContext } from '../../../context';
import { CircularGauge, Scale, Label, RangeContainer, Range } from 'devextreme-react/circular-gauge';
import StackedBarQM from './StackedBar/StackedBarQM';
import StackedBarCase from './StackedBar/StackedBarCase';

const colorSet = {
    a: "#71A2D2",
    b: "#90BF38",
    c: "#6264A7",
    d: "#DF6F15",
    e: "#b47d49"
};

const palette = [colorSet.d, colorSet.b, colorSet.c, colorSet.a, colorSet.e];
const source = [
    { value: 'inbound', name: 'Inbound' },
    { value: 'outbound', name: 'Outbound' },
    { value: 'meeting', name: 'Meeting' },
    { value: 'intern', name: 'Internal' },
    { value: 'chat', name: 'Chat' },
    { value: 'upload', name: 'Upload' },
    { value: 'SMS', name: 'SMS' },
    //{ value: 'unknown', name: 'Other' },
];
const sourceHit = [
    { value: 'hit', name: 'Hit' },
    { value: 'noHit', name: 'No hit' }
];
const sourceCompare = [
    { value: 'total', name: 'Total' },
    { value: 'recorded', name: 'Recorded' },
    { value: 'error', name: 'Error' }
];

const sourceLoss = [
    { value: 'noError', name: 'No' },
    { value: 'onlySilence', name: 'Only Silence' },
    { value: 'lessDuration', name: 'Less Duration' },
    { value: 'packetLoss', name: 'Packet Loss' },
    { value: 'onlyTranscript', name: 'Only Transcript' },
    { value: 'totalLoss', name: 'Total Loss' },
    { value: 'callTry', name: 'Call Try' },
    { value: 'processing', name: 'Processing' },
    { value: 'single', name: 'Single' },
    { value: 'ongoing', name: 'Ongoing' },
    { value: 'otherUser', name: 'Other User' },
    { value: 'audioLoss', name: 'Audio Loss' },
    { value: 'processingError', name: 'Processing Error' },
    { value: 'noTranscript', name: 'No Transcript' },
    { value: 'errorTranscript', name: 'Transcript Error' },
    { value: 'videoLoss', name: 'Video Loss' },
    { value: 'irretrievableCall', name: 'Irretrievable Call' },
    { value: 'msftInviteError', name: 'MSFT Invite Error' }
];

const sourceTotal = [
    { value: 'inbound', name: 'Total' },
];

const sourceAvarage = [
    { value: 'inbound', name: 'Avarage' },
]

const sourceDays = [
    { value: 'inbound', name: 'Days' },
]

class HealthCheck extends React.Component {
    render() {
        return (
            generateElement(this.props.title,
                <div style={{
                    height: "100%",
                    width: "100%",
                    textAlign: "center",
                    color: this.props.color,
                    fontSize: 30,
                }
                }>
                    <Icon iconName={"Robot"} />{this.props.val}
                    <br />
                    <Icon iconName={"CloudImportExport"} />000
                    <br />
                    <br />

                </div>)
        );
    }
}

class SimpleCounter extends React.Component {

    render() {
        return (
            generateElement(this.props.title,
                <div>
                    <div style={{
                        height: "100%",
                        width: "100%",
                        textAlign: "center",
                        color: this.props.color,
                        fontSize: 60,

                    }
                    }>
                        {this.props.val}
                    </div>
                    <div style={{ fontSize: 20, color: this.props.color }}>{this.props.overflow ? " overflow" : ""}<br /></div>
                </div>
            )
        );
    }
}

class QMCounter extends React.Component {
    static contextType = MyContext
    render() {
        return (
            generateElement(this.props.title,
                <div>
                    <div style={{
                        height: "100%",
                        width: "100%",
                        textAlign: "center",
                        color: this.props.color,
                        fontSize: 30,

                    }
                    }>
                        {this.props.valueType === "average" ? `${this.props.val} ${this.context.getTranslation("compliance", "points")}` : `${this.props.val}`}
                    </div>
                    <div style={{
                        height: "100%",
                        width: "100%",
                        textAlign: "center",
                        color: this.props.color,
                        fontSize: 30,

                    }
                    }>
                        {`${this.props.evaluations} ${this.context.getTranslation("compliance", "evaluations")}`}
                    </div>
                    <div style={{ fonstSize: 10 }}><br /></div>
                </div>
            )
        );
    }
}


class SimpleBarExChart extends React.Component {

    customizeTooltip = ({ seriesName, valueText }) => {
        if (this.props.kpi === "QMAgentCompared") {
            return {
                text: `${valueText}/${this.props.defaultVisualRange[1]}`,
            };
        } else {
            return {
                text: `${valueText}`,
            };
        }
    }

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }

        let series = this.props.series || [
            {
                argumentField: "args",
                valueField: "value",
                name: "value"
            }];

        if (this.props.kpi === "PolicyCompared" || this.props.kpi === "CategoryCompared") {
            series = [
                {
                    argumentField: "args",
                    valueField: "hit",
                    name: "Hit"
                },
                {

                    argumentField: "args",
                    valueField: "noHit",
                    name: "No hit"
                }
            ]
        }
        let getMoreSeries = series.length > 1;


        return (
            generateElement(this.props.title,
                <div style={{
                    width: w,
                    height: h,
                    margin: { top: 5, right: 30, left: 20, bottom: 5 },
                    textAlign: "center",
                    fontSize: "100pt"
                }
                }>
                    <Chart dataSource={this.props.data}
                        palette={this.props.palette}
                        ref={this.props.reference}
                        height={h - 55}
                        width={w - 55}
                        rotated={this.props.type == "user" ? true : false}
                    >

                        <Size
                            height={h - 55}
                        />
                        <ArgumentAxis tickInterval={10} defaultVisualRange={this.props.defaultVisualRange} />
                        <ValueAxis
                            defaultVisualRange={this.props.defaultVisualRange}
                        />
                        <CommonSeriesSettings
                            type="bar"
                            argumentField="args"
                            ignoreEmptyPoints={true}
                        />
                        {series.map(s => (
                            <Series
                                key={s.name}
                                valueField={s.valueField}
                                argumentField={s.argumentField}
                                name={s.name}
                                type="bar"
                            />
                        ))}
                        <Legend visible={getMoreSeries} />
                        <Tooltip enabled={true} container="#chart-modal" customizeTooltip={this.customizeTooltip} />
                    </Chart>
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div>
            )
        );
    }
}

class WorldMapExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div
                    ref={this.props.reference}
                >
                    <WorldMap
                        size={{ width: w, height: h }}
                        reference={this.props.reference}
                    />

                </div>
            )
        );
    }
}

class PiExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <PieChartDex
                        kpi={this.props.kpi}
                        palette={this.props.palette}
                        reference={this.props.reference}
                        data={this.props.data}
                        size={{
                            width: w,
                            height: h
                        }} />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div >
            )
        );
    }
}

// Important Widgets

class SplineExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <SplineChart size={{
                        width: w,
                        height: h
                    }}
                        palette={this.props.palette}
                        kpi={this.props.kpi}
                        reference={this.props.reference}
                        source={this.props.source}
                        data={this.props.data}
                        defaultVisualRange={this.props.defaultVisualRange}
                    />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div >
            )
        );
    }
}

class DoughnutExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <Doughnut size={{
                        width: w,
                        height: h
                    }}
                        kpi={this.props.kpi}
                        reference={this.props.reference}
                        palette={this.props.palette}
                        data={this.props.data}
                        labelCenter={this.props.labelCenter}
                    />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div>
            )
        );
    }
}

class StackedBarExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        switch (this.props.kpi) {
            case "GCTA":
            case "CTA":
            case "COA":
            case "CIA":
            case "CMA":
            case "CEAA":
                return (
                    generateElement(this.props.title,
                        <div>
                            <StackedBarCompare size={{
                                width: w,
                                height: h
                            }}
                                palette={this.props.palette}
                                reference={this.props.reference}
                                data={this.props.data}
                            />
                            {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                        </div >
                    ));
            case "GCNR":
            case "CNR":
                return (
                    generateElement(this.props.title,
                        <div>
                            <StackedBarLoss size={{
                                width: w,
                                height: h
                            }}
                                palette={this.props.palette}
                                reference={this.props.reference}
                                data={this.props.data}
                                problemType={this.props.problemType}

                            />
                            {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                        </div >
                    ));
            case "QMAgentCompared": {
                return (
                    generateElement(this.props.title,
                        <StackedBarQM size={{
                            width: w,
                            height: h
                        }}
                            palette={this.props.palette}
                            isModal={this.props.isModal}
                            changeSectionInfo={this.props.changeSectionInfo}
                            sectionName={this.props.sectionName}
                            reference={this.props.reference}
                            data={this.props.data}
                            type={this.props.type}
                            name={this.props.name}
                            persons={this.props.persons}
                        />
                    ));
            }
            case "OverallEscalationRate":
            case "OverallComplianceRate":
            case "CaseComplianceRate":
            case "CaseEscalationRate":
                {
                    return (
                        generateElement(this.props.title,
                            <StackedBarCase size={{
                                width: w,
                                height: h
                            }}
                                palette={this.props.palette}
                                reference={this.props.reference}
                                data={this.props.data}
                                persons={this.props.persons}
                                kpi={this.props.kpi}
                                type={this.props.type}
                            />
                        ));
                }
            default:
                return (
                    generateElement(this.props.title,
                        <div>
                            <StackedBar size={{
                                width: w,
                                height: h
                            }}
                                palette={this.props.palette}
                                reference={this.props.reference}
                                data={this.props.data}
                                convType={this.props.convType}
                            />
                            {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                        </div >
                    ));
        }
    }
}

class TreeMapExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <TreeMaping size={{
                        width: w,
                        height: h
                    }}
                        palette={this.props.palette}
                        reference={this.props.reference}
                        data={this.props.data}
                    />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div >
            )
        );
    }
}

class FunnelExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <FunnelChart size={{
                        width: w,
                        height: h
                    }}
                        palette={this.props.palette}
                        reference={this.props.reference}
                        data={this.props.data}
                    />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div >
            )
        );
    }
}

class BubbleExChart extends React.Component {

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }
        return (
            generateElement(this.props.title,
                <div>
                    <BubbleChart size={{
                        width: w,
                        height: h
                    }}
                        palette={this.props.palette}
                        reference={this.props.reference}
                        data={this.props.data}
                    />
                    {this.props.overflow && <div style={{ fontSize: 20, color: this.props.color }}>overflow</div>}
                </div >
            )
        );
    }
}

class SpeedometerChart extends React.Component {

    customizeText({ valueText }) {
        return `${valueText}%`;
    }

    render() {
        let w, h;

        if (this.props.size.width === -1) {
            w = window.innerWidth * 0.9;
            h = window.innerHeight * 0.9;
        } else {

            h = this.props.size.height;
            w = this.props.size.width;

        }

        const defaultRanges = [
            { minRange: 0, maxRange: 20, color: '#8B0000' },
            { minRange: 21, maxRange: 40, color: '#FF8C00' },
            { minRange: 41, maxRange: 60, color: '#FFD700' },
            { minRange: 61, maxRange: 80, color: '#9ACD32' },
            { minRange: 81, maxRange: 100, color: '#2E8B57' }
        ]
        const defaultRengeReverse = [
            { minRange: 0, maxRange: 20, color: '#2E8B57' },
            { minRange: 21, maxRange: 40, color: '#9ACD32' },
            { minRange: 41, maxRange: 60, color: '#FFD700' },
            { minRange: 61, maxRange: 80, color: '#FF8C00' },
            { minRange: 81, maxRange: 100, color: '#8B0000' }
        ]

        const useCustomRange = this.props.range && this.props.range.length > 0;

        const ranges = useCustomRange ? this.props.range :
            (this.props.reverse ? defaultRengeReverse : defaultRanges);

        const endValue = this.props.scale?.endValue ? this.props.scale.endValue : 100;
        const tickInterval = this.props.scale?.tickInterval ? this.props.scale.tickInterval : 20;

        return (
            generateElement(this.props.title,
                <CircularGauge
                    id="gauge"
                    value={this.props.value}
                    size={{
                        width: w,
                        height: h
                    }}
                    reference={this.props.reference}
                >
                    <Scale startValue={0} endValue={endValue} tickInterval={tickInterval}>
                        {useCustomRange && <Label />}
                        {!useCustomRange && <Label customizeText={this.customizeText} />}
                    </Scale>
                    <RangeContainer>
                        {ranges.map((r, i) => {
                            return (<Range key={i} startValue={r.minRange - 1} endValue={r.maxRange} color={r.color} />)
                        })}
                    </RangeContainer>
                    <Tooltip
                        enabled={true}
                        customizeTooltip={({ value }) => {
                            return {
                                text: useCustomRange ? value : `${value}%`
                            };
                        }} />
                </CircularGauge>
            )
        );
    }
}

export {
    SimpleBarExChart,
    WorldMapExChart,
    PiExChart,
    SplineExChart,
    DoughnutExChart,
    StackedBarExChart,
    TreeMapExChart,
    FunnelExChart,
    BubbleExChart,
    SimpleCounter,
    QMCounter,
    palette,
    colorSet,
    source,
    sourceCompare,
    sourceLoss,
    sourceTotal,
    sourceHit,
    HealthCheck,
    SpeedometerChart,
    sourceAvarage,
    sourceDays
}